import { render, staticRenderFns } from "./image-text-detail.vue?vue&type=template&id=b58e94fa&scoped=true&"
import script from "./image-text-detail.vue?vue&type=script&lang=js&"
export * from "./image-text-detail.vue?vue&type=script&lang=js&"
import style0 from "./image-text-detail.vue?vue&type=style&index=0&id=b58e94fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58e94fa",
  null
  
)

export default component.exports